import { ComponentProps } from 'lib/component-props';
import { usePageData } from 'lib/page-data/PageDataContext';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import { useI18n } from 'next-localization';
import Badge from 'components/includes/Badge/Badge';

const HelpArticleHero = ({ rendering }: ComponentProps): JSX.Element => {
  const helpArticleData = usePageData('helpArticle') ?? {};
  const { sitecoreContext } = useSitecoreContext();
  const { t } = useI18n();

  const title = helpArticleData?.helpTitle.value;
  const strapline = helpArticleData?.helpStrapline.value;
  const helpTagText = helpArticleData?.helpTag?.targetItem?.name.value;

  if (sitecoreContext.pageEditing) {
    return <EEPlaceholder>Help Article Banner</EEPlaceholder>;
  }

  return (
    <section
      data-e2e-component-uid={rendering.uid}
      className="default-section-padding background-primary text-white"
    >
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <span className="h5 me-2">{t('help')}</span>
            {!!helpTagText && <Badge>{helpTagText}</Badge>}
            {!!title && <h1 className="mt-2">{title}</h1>}
            {!!strapline && <p className="mt-2 body-large">{strapline}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpArticleHero;
